const initialState = {
  listPembinaan: [],
  kpi2: null,
};

const pembinaanReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "SET_LISTPEMBINAAN":
      return {
        ...state,
        listPembinaan: data,
      };
    case "SET_KPI2PEMBINAAN":
      return {
        ...state,
        kpi2: data,
      };

    default:
      return state;
  }
};

export default pembinaanReducer;
